import { render, staticRenderFns } from "./CustomTagEntry.vue?vue&type=template&id=61303e72&"
import script from "./CustomTagEntry.vue?vue&type=script&lang=js&"
export * from "./CustomTagEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports